<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>自媒体管理</a-breadcrumb-item>
    <a-breadcrumb-item>视频翻译任务</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 筛选查询 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input v-model:value="dramaNameModel" class="tool-item" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">创建人：</a-col>
          <a-col :span="18">
            <a-select v-model:value="adminIdModel" class="tool-item" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in adminList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">目标语种：</a-col>
          <a-col :span="18">
            <a-select v-model:value="targetLangIdModel" class="tool-item" placeholder="请选择" allow-clear>
              <a-select-option v-for="item in languages" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <template #bodyCell="{ column, record }">
      <!-- 剧名：单行省略 + tooltip 看全 -->
      <template v-if="column.key === 'name'">
        <a-tooltip :title="record.name || '-'">
          <span class="cell-name-ellipsis">{{ record.name ?? '-' }}</span>
        </a-tooltip>
      </template>
      <!-- 源视频版本 -->
      <template v-else-if="column.key === 'type'">
        {{ YoutubeVideoTypes.find(item => item.value === record.type)?.text || '-' }}
      </template>
      <!-- 目标语种 -->
      <template v-else-if="column.key === 'target_lang_id'">
        {{ languages.find(item => item.id === record.target_lang_id)?.name || '-' }}
      </template>
      <!-- 音色 -->
      <template v-else-if="column.key === 'speech_type'">
        {{ SpeechTypes.find(item => item.value === record.speech_type)?.text || '-' }}
      </template>
      <!-- 长视频 -->
      <template v-else-if="column.key === 'long_status'">
        <template v-if="record.long_status === VideoExportStatus.processing.value">
          <a-badge :color="VideoExportStatus.processing.color" :text="VideoExportStatus.processing.text"></a-badge>
        </template>
        <template v-else-if="record.long_status === VideoExportStatus.success.value">
          <a @click="touchPreview(record)">预览</a>
          <span v-if="!record.sfx_status" style="color: #999; margin-left: 4px;">（无音效）</span>
        </template>
        <template v-else-if="record.long_status === VideoExportStatus.failed.value">
          <a-badge :color="VideoExportStatus.failed.color" :text="VideoExportStatus.failed.text"></a-badge>
        </template>
        <template v-else>
          <a-badge :color="VideoExportStatus.none.color" text="未合成"></a-badge>
        </template>
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchTask(record)">查看任务</a>
        <a-dropdown>
          <a class="operation-item">合并视频 <down-outlined /></a>
          <template #overlay>
            <a-menu @click="({ key }) => handleMergeClick(key, record)">
              <a-menu-item key="direct">直接合并</a-menu-item>
              <a-menu-item key="sfx">音效合并</a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <a
          :class="['operation-item', { 'operation-item-disabled': record.long_status !== VideoExportStatus.success.value }]"
          @click="record.long_status === VideoExportStatus.success.value && touchPublishToYoutube(record)"
        >
          发布至油管
        </a>
      </template>
      <template v-else>
        {{ record[column.key] ?? '-' }}
      </template>
    </template>
  </a-table>

  <Loading :loading="isLoading"></Loading>
  <PreviewVideoModal ref="RefPreviewModal"></PreviewVideoModal>
  <Viewtasks ref="RefViewtasks" @success="getList"></Viewtasks>
  <PublishToYoutube ref="RefPublishToYoutube" @success="getList"></PublishToYoutube>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import { message, Modal } from 'ant-design-vue'
import dayjs from 'dayjs'
import Pub from '@/utils/public'
import Loading from '@/components/Loading'
import PreviewVideoModal from '@/components/preview/PreviewVideoModal.vue'
import Viewtasks from './components-youtube/ViewTasks'
import PublishToYoutube from './components-youtube/PublishToYoutube'
import { VideoExportStatus, YoutubeVideoTypes, SpeechTypes } from '@/utils/constantList'
import { listAll, taskLongVideo, langSearchList } from '@/api/admin'
import { userList } from '@/api/request'

let RefPreviewModal = ref(null)
let RefViewtasks = ref(null)
let RefPublishToYoutube = ref(null)
let isLoading = ref(false)
let dataSource = ref([])
let languages = ref([])
let adminList = ref([])
let dramaNameModel = ref(undefined)
let adminIdModel = ref(undefined)
let targetLangIdModel = ref(undefined)
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

let columns = ref([
  { title: 'ID', dataIndex: 'id', key: 'id' },
  { title: '剧名1', dataIndex: 'name', key: 'name' },
  { title: '源视频版本', dataIndex: 'type', key: 'type' },
  { title: '目标语种', dataIndex: 'target_lang_id', key: 'target_lang_id' },
  { title: '音色', dataIndex: 'speech_type', key: 'speech_type' },
  { title: '翻译方式', dataIndex: 'translation_type_list', key: 'translation_type_list', width: 110 },
  { title: '长视频', dataIndex: 'long_status', key: 'long_status' },
  { title: '创建人', dataIndex: 'admin_name', key: 'admin_name' },
  { title: '创建日期', dataIndex: 'created_date', key: 'created_date' },
  { title: '操作', dataIndex: 'operation', key: 'operation', width: 190 }
])

onBeforeMount(() => {
  getLanguageList()
  getAdminList()
  getList()
})

function getLanguageList() {
  langSearchList().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      languages.value = data
    } else {
      message.error(res.message || msg)
    }
  })
}

function getAdminList() {
  userList({ page: 1, page_size: 500 }).then(res => {
    const { code, data } = res
    if (code === 0 && data && Array.isArray(data.data)) {
      adminList.value = (data.data || []).map(item => ({
        id: item.id,
        name: item.nickname || item.username || String(item.id)
      }))
    }
  })
}

function touchSearch() {
  pagination.current = 1
  getList()
}

function touchReset() {
  dramaNameModel.value = undefined
  adminIdModel.value = undefined
  targetLangIdModel.value = undefined
  pagination.current = 1
  getList()
}

function handleTableChange(p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

function touchTask(record) {
  const dramaDetail = { id: record.drama_id, name: record.name || '-' }
  RefViewtasks.value.showDrawer(dramaDetail, record)
}

function touchPreview(record) {
  const dramaDetail = { id: record.drama_id, name: record.name || '-' }
  RefPreviewModal.value.showModal(record.long_video_url, dramaDetail?.name)
}

function handleMergeClick(key, record) {
  const isSfx = key === 'sfx'
  if (record.long_status === VideoExportStatus.processing.value) {
    Modal.info({
      title: '合并任务正在进行中',
      content: '请勿重复操作',
      okText: '好的',
      cancelButtonProps: { style: { display: 'none' } }
    })
    return
  }
  if (record.long_status === VideoExportStatus.success.value) {
    Modal.confirm({
      title: '已合并过长视频，确认要重新合并吗？',
      okText: '是',
      cancelText: '否',
      onOk: () => doMergeVideo(record, isSfx)
    })
  } else {
    doMergeVideo(record, isSfx)
  }
}

function doMergeVideo(record, isSfx = false) {
  const params = { task_id: record.id, sfx_status: isSfx ? 1 : 0 }
  taskLongVideo(params).then(res => {
    isLoading.value = false
    const { code, msg } = res
    if (code === 0) {
      message.success(res.message)
      getList()
    } else {
      message.error(res.message)
    }
  }).catch(() => {
    isLoading.value = false
    message.error('合并失败')
  })
}

function touchPublishToYoutube(record) {
  const dramaDetail = { id: record.drama_id, name: record.name || '-' }
  RefPublishToYoutube.value.showDrawer(record, dramaDetail)
}

function getList() {
  isLoading.value = true
  const params = {
    name: dramaNameModel.value,
    admin_id: adminIdModel.value,
    target_lang_id: targetLangIdModel.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  listAll(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      const list = data.data || []
      list.forEach(item => {
        const videoType = YoutubeVideoTypes.find(vt => vt.value === item.type)?.text || '-'
        const targetLang = languages.value.find(lang => lang.id === item.target_lang_id)?.name || '-'
        item.type2target_text = `${videoType} → ${targetLang}`
      })
      dataSource.value = list
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>
.tool-row {
  margin-bottom: 16px;
}

.tool-title {
  text-align: right;
}

.tool-item {
  width: 100%;
}

.table-view {
  background: #fff;
  border-radius: 6px;
}

.cell-name-ellipsis {
  width: 180px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.operation-item {
  color: #1890ff;
  margin-right: 16px;
  cursor: pointer;
}

.operation-item:hover {
  color: #40a9ff;
}

.operation-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.operation-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
}
</style>
